import { render, staticRenderFns } from "./ChooseResource.vue?vue&type=template&id=0bf11628&scoped=true&"
import script from "./ChooseResource.vue?vue&type=script&lang=js&"
export * from "./ChooseResource.vue?vue&type=script&lang=js&"
import style0 from "./ChooseResource.vue?vue&type=style&index=0&id=0bf11628&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bf11628",
  null
  
)

export default component.exports